import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import { formatDate } from '../../utils/formatDate';

const StatusChip = ({ sentAt }) => (
    <Chip
        label={sentAt ? 'Enviada' : 'Pendente'}
        size='small'
        color={sentAt ? 'success' : 'warning'}
        variant={sentAt ? 'filled' : 'outlined'}
    />
);

const ActionTypeLabel = ({ actionType }) => {
    const labels = {
        EVENT: 'Evento',
        CONTENT: 'Conteúdo',
        PRODUCT: 'Produto',
        URL: 'URL',
        NONE: 'Nenhuma',
    };
    return labels[actionType] || actionType;
};

export default function NotificationCampaignList({ campaigns, onClick }) {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                marginTop: '16px',
                overflow: 'hidden',
            }}
        >
            {campaigns.map((c, index) => (
                <Box
                    key={c.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== campaigns.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': { backgroundColor: '#f9f9f9' },
                    }}
                    onClick={() => onClick?.(c)}
                >
                    <Stack
                        direction='row'
                        justifyContent='space-between'
                        alignItems='center'
                        spacing={2}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: 16,
                                fontWeight: 500,
                                color: '#292929',
                            }}
                        >
                            {c.title}
                        </Typography>
                        <StatusChip sentAt={c.sentAt} />
                    </Stack>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 12,
                            color: '#777',
                            mt: 0.5,
                        }}
                    >
                        {c.message?.slice(0, 90) || '-'}
                        {c.message?.length > 90 ? '...' : ''}
                    </Typography>

                    <Stack
                        direction='row'
                        spacing={1.5}
                        sx={{ mt: 1, alignItems: 'center', flexWrap: 'wrap' }}
                    >
                        <Typography sx={{ fontSize: 12, color: '#555' }}>
                            Tipo:{' '}
                            <strong>
                                <ActionTypeLabel actionType={c.actionType} />
                            </strong>
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: '#555' }}>
                            Criada: <strong>{formatDate(c.createdAt)}</strong>
                        </Typography>
                    </Stack>
                </Box>
            ))}
        </Box>
    );
}
